var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconLocaleRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.985,
    height: 34.979,
    viewBox: "0 0 24.985 34.979",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "placeholder",
    d: "M18.492,2A12.661,12.661,0,0,0,6,14.492c0,9.788,11.118,21.6,11.587,22.1a1.249,1.249,0,0,0,1.811,0c.468-.5,11.587-12.31,11.587-22.1A12.661,12.661,0,0,0,18.492,2Zm0,17.489a5,5,0,1,1,5-5A5,5,0,0,1,18.492,19.489Z",
    transform: "translate(-6 -2)",
    fill: "#9f393a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLocaleRed);
export default __webpack_public_path__ + "static/media/icon-locale-red.c4e46ed9b72907095c9c2a7c37e29947.svg";
export { ForwardRef as ReactComponent };